(function (angular) {
  "use strict";

  angular
    .module("alk.companyAdmin")
    .controller("companyAdminController", companyAdminController);

  companyAdminController.$inject = ["UserProvider"];

  function companyAdminController(UserProvider) {
    var hasCompanyAdminAccess = false;
    let vm = this;
    vm.activeTab = "users";
    if (UserProvider.getUser().roles[0] === "ALK Administrator" || UserProvider.getUser().roles[0] === "ALK Support" ||
      UserProvider.getUser().roles[0] === "Company Administrator" || UserProvider.getUser().roles[0] === "cloudxchange Approver"
      || (UserProvider.getUser().roles[0] && UserProvider.getUser().roles[0].toLowerCase() === "support")) {
      this.hasCompanyAdminAccess = true;
    }
  }
})(window.angular);




// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-company-admin/companyAdmin.controller.js